import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import { MakeAdminOtherUser } from "../../api/api";

type PayloadResult = {
  status: string;
  msg?: string;
};

type AssignPayloadConfig = {
  email: string;
  role: string;
};

export const useAssignRole = () => {
  const { getAccessTokenSilently } = useAuth0();

  const mutation = useMutation({
    mutationFn: ({
      email,
      role,
      token,
    }: AssignPayloadConfig & {
      token: string;
    }): Promise<PayloadResult> =>
      MakeAdminOtherUser(token, {
        email,
        role,
      }),

    onSuccess: (data) => {},

    onError: (error) => {
      console.error(error);
    },
  });

  const mutateWithToken = useCallback(
    async (
      { email, role }: AssignPayloadConfig,
      options?: {
        onSuccess?: (data: PayloadResult) => void;
        onError?: (error: any) => void;
        onSettled?: () => void;
      }
    ) => {
      const token = await getAccessTokenSilently();
      console.log();
      mutation.mutate(
        {
          email,
          role,
          token,
        },
        {
          onSuccess: options?.onSuccess,
          onError: options?.onError,
          onSettled: options?.onSettled,
        }
      );
    },
    [getAccessTokenSilently, mutation]
  );

  return { ...mutation, mutate: mutateWithToken };
};
